import clsx from 'clsx';
import { FC, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import styles from './sign-up.module.scss';

import { ISignUpProps } from './types';

import SignUpForm from '../sign-up-form';

import { Paragraph } from '../ui';

export const SignUp: FC<ISignUpProps> = ({ className = '', ...rest }) => {
  const [isHidden, setIsHidden] = useState(false);

  const { t } = useTranslation();

  if (localStorage.getItem('access')) return <Navigate to='/' replace />;

  return (
    <section className={clsx(styles.signup, { [className]: className })} {...rest}>
      <div className={styles.logo} />
      {!isHidden && <Paragraph className={styles.text}>{t('sign-up.subtitle')}</Paragraph>}
      <SignUpForm setIsHidden={setIsHidden} />
    </section>
  );
};
